import { ACTION_TYPE } from '../constants/actionType'

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.setWalletAddress: {
      const { walletAddress } = action.payload
      return walletAddress
    }
    default: {
      return state
    }
  }
}

const initialState = ''

const initialize = (initialState = '') => initialState

const reducerArgs = [reducer, initialState, initialize]

export default reducerArgs
